// import store from '@/store'

const state = {
  expansionPanel: 0,
  isLoading: false,
  activeTab: null
}

const getters = {
  getIsLoading (state) {
    return state.isLoading
  },
  getExpansionPanel (state) {
    return state.expansionPanel
  },
  getActiveTab (state) {
    return state.activeTab
  }
}

const actions = {}

const mutations = {
  setIsLoading (state, isLoading) {
    state.isLoading = isLoading
  },
  setExpansionPanel (state, expansionPanel) {
    state.expansionPanel = expansionPanel
  },
  setActiveTab (state, activeTab) {
    state.activeTab = activeTab
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/featureTabs.js